// extracted by mini-css-extract-plugin
export default {"userInfo":"UserInfo_userInfo__e2m98"};